import React, {useContext} from "react";
import DropDown from "./Dropdown";
import Context from "../ProductsProvider";

const DropDownContainer = () => {
	const { data: { language, sortOptions },
	} = useContext(Context);

	if (!sortOptions) return;

	return (
		<>
			{
				sortOptions[language].map((list) => {
					return (
						<DropDown
							key={list.key}
							filterKey={list.key}
							dropDownFilters={list.filters}
						/>
					);
				})
			}
		</>
	);
}

export default DropDownContainer;
